module.exports = __webpack_public_path__ + "img/ur3_05.0a167fed.jpg";